module.exports = __webpack_public_path__ + "img/lezhi02.921222b8.png";